import React from 'react';

function CapabilityCard({ title, description, stats }) {
  return (
    <div style={{ maxWidth: '640px', width: '100%', margin: '0 auto var(--spacing-xl)' }}>
      <div className="cap-card">
        <h2 className="cap-headline">{title}</h2>
        <p className="cap-body">{description}</p>
        <div className="cap-stats">
          {stats.map((stat, i) => (
            <div key={i} className="cap-pill">
              <div className="cap-pill-value">{stat.value}</div>
              <div className="cap-pill-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CapabilityCard;
